var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-8 my-12"},_vm._l((_vm.enhanceFeatureData),function(cardData,i){return _c('Card',_vm._b({key:`cardData-${i}`,attrs:{"testimonialData":_vm.testimonials[cardData.order]}},'Card',cardData,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }